var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-64 mx-8 my-16 text-center"},[_c('div',{ref:"name-and-title",staticClass:"inline-block h-32 text-6xl font-bold text-white"},[_vm._v("\n    NOAH KUMPF\n  ")]),_c('Carousel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }